module.exports = __webpack_public_path__ + "static/img/49.54f0cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/49.png
// module id = ifZR
// module chunks = 0